import axios from 'axios'
import { getUrlBackApi }  from './urls'
import { TOKEN_DEFAULT } from './security';

const SERVER_BACKEND = getUrlBackApi()

export function apiGet(url) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    const token = user  ? user.token : TOKEN_DEFAULT;

    return axios.get(SERVER_BACKEND + url, 
                      { headers : { 'Authorization': 'Bearer ' + token , 
                                    'content-type' :  'application/json;charset=utf-8',
                                    'Access-Control-Allow-Origin': '*'
                                }});
}

export function apiPost(url, data) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    const token = user  ? user.token : TOKEN_DEFAULT;

    return axios.post(SERVER_BACKEND + url, 
                      data,
                      { headers : { 'Authorization': 'Bearer ' + token , 
                                    'content-type' :  'application/json;charset=utf-8',
                                    'Access-Control-Allow-Origin': '*'
                                }});
}

export function apiPostForm(url, data) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    return axios.post(SERVER_BACKEND + url, 
                      data,
                      { headers : { 'Authorization': 'Bearer ' + user.token , 
                                    'content-type' : 'multipart/form-data',
                                    'Access-Control-Allow-Origin': '*'

                                }} );
}


export function apiPut(url,data) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    return axios.put(SERVER_BACKEND + url, 
                      data,
                      { headers : { 'Authorization': 'Bearer ' + user.token , 
                                    'content-type' :  'application/json;charset=utf-8',
                                    'Access-Control-Allow-Origin': '*'
                                }});
}

export function apiDelete(url) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    return axios.delete(SERVER_BACKEND + url, 
                      { headers : { 'Authorization': 'Bearer ' + user.token , 
                                    'content-type' :  'application/json;charset=utf-8',
                                    'Access-Control-Allow-Origin': '*'
                                }});
}
